import React from 'react';

/** Soft blue orbs/gradients for marketing pages — matches hero theme. */
export default function PageAtmosphere({ variant = 'default' }) {
  return (
    <div className={`page-atmosphere page-atmosphere--${variant}`} aria-hidden="true">
      <div className="page-atmosphere__orb page-atmosphere__orb--a" />
      <div className="page-atmosphere__orb page-atmosphere__orb--b" />
      <div className="page-atmosphere__orb page-atmosphere__orb--c" />
      <div className="page-atmosphere__grain" />
    </div>
  );
}
